import { svg } from 'lit';

const symbol = svg`<svg width="12" height="13" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="3" r="2.75" stroke="#fff" stroke-width=".5"/><path d="M11.745 12.75H.255a5.75 5.75 0 0111.49 0z" stroke="#fff" stroke-width=".5"/></svg>`;

export { symbol as default };
